import { labels as enLabels }  from './en.js';
import { labels as ptLabels }  from './pt.js';

const labels = {
    ...enLabels,
    ...ptLabels
};

export { labels }